export function resolveAssetImageSrc(src) {
  if (!src) return '/asset-types/asset-default.svg';
  if (/^https?:\/\//i.test(src) || src.startsWith('data:')) return src;
  if (src.startsWith('/uploads/')) {
    const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:3001';
    return `${apiUrl}${src}`;
  }
  return src;
}

export const DEFAULT_ASSET_CONFIG = {
  asset_types: [
    { value: 'pre_brush', label: 'Pre-Brush', image: '/asset-types/pre-brush.svg', summary: 'Brush preparation unit', active: true, default_service_interval_months: 12, warranty_months: 12, maintenance_model: 'robot_plan', contract_months: 60, wear: { brush_days: 180, drive_belt_days: 365 } },
    { value: 'post_spray', label: 'Post-Spray', image: '/asset-types/post-spray.svg', summary: 'Post-milking spray unit', active: true, default_service_interval_months: 12, warranty_months: 12, maintenance_model: 'robot_plan', contract_months: 60, wear: { nozzle_days: 180, drive_belt_days: 365 } },
    { value: 'pre_spray', label: 'Pre-Spray', image: '/asset-types/pre-spray.svg', summary: 'Pre-milking spray unit', active: true, default_service_interval_months: 12, warranty_months: 12, maintenance_model: 'robot_plan', contract_months: 60, wear: { nozzle_days: 180, drive_belt_days: 365 } },
    { value: 'dual_pre_brush', label: 'Dual Pre-Brush', image: '/asset-types/dual-pre-brush.svg', summary: 'Dual brush preparation unit', active: true, default_service_interval_months: 12, warranty_months: 12, maintenance_model: 'robot_plan', contract_months: 60, wear: { brush_days: 180, drive_belt_days: 365 } },
    { value: 'dual_post_spray', label: 'Dual Post-Spray', image: '/asset-types/dual-post-spray.svg', summary: 'Dual post-milking spray unit', active: true, default_service_interval_months: 12, warranty_months: 12, maintenance_model: 'robot_plan', contract_months: 60, wear: { nozzle_days: 180, drive_belt_days: 365 } },
    { value: 'dual_pre_spray', label: 'Dual Pre-Spray', image: '/asset-types/dual-pre-spray.svg', summary: 'Dual pre-milking spray unit', active: true, default_service_interval_months: 12, warranty_months: 12, maintenance_model: 'robot_plan', contract_months: 60, wear: { nozzle_days: 180, drive_belt_days: 365 } },
    { value: 'bci_parlour', label: 'BCI Parlour', image: '/asset-types/bci-parlour.svg', summary: 'Parlour BCI installation', active: true, default_service_interval_months: 12, warranty_months: 12, maintenance_model: 'cadence', wear: { drive_belt_days: 365 } },
    { value: 'bci_race', label: 'BCI Race', image: '/asset-types/bci-race.svg', summary: 'Race BCI installation', active: true, default_service_interval_months: 12, warranty_months: 12, maintenance_model: 'cadence', wear: { drive_belt_days: 365 } },
    { value: 'ids_vision', label: 'Barn Vision', image: '/asset-types/ids-vision.svg', summary: 'Barn vision monitoring unit', active: true, default_service_interval_months: 12, warranty_months: 12, maintenance_model: 'cadence', wear: {} },
    { value: 'id_verify', label: 'ID Verify', image: '/asset-types/id-verify.svg', summary: 'Identity verification unit', active: true, default_service_interval_months: 12, warranty_months: 12, maintenance_model: 'cadence', wear: {} },
    { value: 'collar', label: 'Collar', image: '/asset-types/collar.svg', summary: 'Animal collar device', active: true, default_service_interval_months: 12, warranty_months: 12, maintenance_model: 'cadence', wear: {} },
    { value: 'i_qube', label: 'i-Qube', image: '/asset-types/i-qube.svg', summary: 'i-Qube control unit', active: true, default_service_interval_months: 12, warranty_months: 12, maintenance_model: 'none', wear: {} },
    { value: 'general_project', label: 'General Project', image: '/asset-types/asset-default.svg', summary: 'Special customer project or custom job', active: true, default_service_interval_months: 12, warranty_months: 0, maintenance_model: 'none', wear: {} },
    // Sellable-only product types (sales rework): quotable line items that are
    // not asset types — excluded from asset-creation pickers via sellable_only.
    { value: 'ddp', label: 'DDP', image: '/asset-types/asset-default.svg', summary: 'Dairy Data Platform subscription', active: true, sellable_only: true, generates_asset: false, asset_form_enabled: false, wear: {} },
    { value: 'collar_install', label: 'Collar Install', image: '/asset-types/asset-default.svg', summary: 'Collar installation service', active: true, sellable_only: true, generates_asset: false, asset_form_enabled: false, wear: {} },
    { value: 'robot_modification', label: 'Robot Modification', image: '/asset-types/asset-default.svg', summary: 'Modification/upgrade of an existing robot', active: true, sellable_only: true, generates_asset: false, asset_form_enabled: false, wear: {} },
    // Orders (2026-10-16): parts and consumables orders, leaving at Delivered.
    { value: 'parts_consumables', label: 'Parts & Consumables', image: '/asset-types/asset-default.svg', summary: 'Spare parts and consumables orders', active: true, sellable_only: true, generates_asset: false, asset_form_enabled: false, wear: {} }
  ],
  statuses: [
    { value: '', label: 'All Statuses' },
    { value: 'pending_install', label: 'Pending Install', active: true },
    { value: 'active', label: 'Active', active: true },
    { value: 'fault', label: 'Fault', active: true },
    { value: 'offline', label: 'Offline', active: true },
    { value: 'decommissioned', label: 'Decommissioned', active: true },
    { value: 'in_warranty', label: 'In Warranty', active: true }
  ],
  health_flags: [
    { value: 'green', label: 'Green', active: true },
    { value: 'amber', label: 'Amber', active: true },
    { value: 'red', label: 'Red', active: true }
  ],
  network_types: [
    { value: '', label: 'Select...', active: true },
    { value: 'ethernet', label: 'Ethernet', active: true },
    { value: 'wifi', label: 'WiFi', active: true },
    { value: '4g', label: '4G', active: true }
  ],
  brush_types: ['Standard brush', 'Heavy duty brush', 'Soft brush'],
  spray_chemicals: ['Iodine', 'Chlorhexidine', 'Lactic acid', 'Other'],
  service_intervals_months: [3, 6, 12, 18, 24],
  warranty_months: [12, 24, 36],
  defaults: {
    service_interval_months: 12,
    warranty_months: 12,
    annual_service_duration_hours: 2,
    health_check_duration_hours: 1,
    remote_access_enabled: false
  }
};

export const ASSET_TYPES = DEFAULT_ASSET_CONFIG.asset_types;

const fallbackType = {
  value: 'unknown',
  label: 'Asset',
  image: '/asset-types/asset-default.svg',
  summary: 'Installed asset'
};

function mergeByValue(defaultItems, savedItems) {
  if (!Array.isArray(savedItems)) return defaultItems;

  const byValue = new Map(savedItems.filter(item => item?.value).map(item => [item.value, item]));
  const merged = defaultItems.map(item => ({ ...item, ...(byValue.get(item.value) || {}) }));
  const extra = savedItems.filter(item => item?.value && !defaultItems.some(defaultItem => defaultItem.value === item.value));
  return [...merged, ...extra];
}

function mergeAssetTypes(defaultTypes, savedTypes) {
  if (!Array.isArray(savedTypes)) return defaultTypes;

  const byValue = new Map(savedTypes.filter(item => item?.value).map(item => [item.value, item]));
  const merged = defaultTypes.map(defaultType => {
    const saved = byValue.get(defaultType.value) || {};
    return {
      ...defaultType,
      ...saved,
      wear: { ...(defaultType.wear || {}), ...(saved.wear || {}) }
    };
  });
  const extra = savedTypes.filter(item => item?.value && !defaultTypes.some(dt => dt.value === item.value));
  return [...merged, ...extra];
}

export function normaliseAssetConfig(config = {}) {
  return {
    ...DEFAULT_ASSET_CONFIG,
    ...config,
    asset_types: mergeAssetTypes(DEFAULT_ASSET_CONFIG.asset_types, config.asset_types),
    statuses: mergeByValue(DEFAULT_ASSET_CONFIG.statuses, config.statuses),
    health_flags: mergeByValue(DEFAULT_ASSET_CONFIG.health_flags, config.health_flags),
    network_types: mergeByValue(DEFAULT_ASSET_CONFIG.network_types, config.network_types),
    defaults: {
      ...DEFAULT_ASSET_CONFIG.defaults,
      ...(config.defaults || {})
    }
  };
}

export function getActiveOptions(items = []) {
  return items.filter(item => item.value === '' || item.active !== false);
}

// Asset-creation pickers must not offer sellable-only product types
// (they are line items on the sales side, never physical assets).
export function getAssetCreatableOptions(items = []) {
  return getActiveOptions(items).filter(item => !item.sellable_only);
}

export function getAssetTypeMeta(value, config = DEFAULT_ASSET_CONFIG) {
  const types = normaliseAssetConfig(config).asset_types;
  return types.find(type => type.value === value) || {
    ...fallbackType,
    value: value || fallbackType.value,
    label: value ? String(value).replace(/_/g, ' ') : fallbackType.label
  };
}

export function getAssetTypeLabel(value, config) {
  return getAssetTypeMeta(value, config).label;
}

export function getOptionLabel(items = [], value) {
  return items.find(item => item.value === value)?.label || (value ? String(value).replace(/_/g, ' ') : '');
}
